import {
    ACTIVE,
    ALERT_ASSET_STATUS_MESSAGE,
    ALERT_UPDATE_ASSET_MESSAGE, ALL_CONFIG,
    ASL_ASSET_TYPE, ENDPOINT_GET_ASL_STATUS, INACTIVE, LOADING_FAILED, LOADING_STRING
} from "../../../util/Constants";
import {
    checkNullAndUndefinedAttribute,
    convertTableJsonToAsset,
    getAPIGatewayPostRequest,
    getNodeId,
    logOperationalMetric
} from "../../../util/Util";
import {addAsset, getAssetByAssetLabel, getAssets, setAssetStatus, updateAsset} from "../../../resources/AssetResource";
import {getAPIGatewayDataFromParent} from "../../../handler/ParentDataHandler";

const metricProcessName = "ASL_DEVICE_DETAILS";

export function fetchAslDeviceDetails(dispatcher) {
    const request = {
        nodeId: getNodeId(),
        assetType: ASL_ASSET_TYPE
    }
    getAslDeviceDetails(dispatcher, request)
}

export function deleteAslDeviceDetails(dispatcher, mac) {
    const request = {
        assetLabel: {
            type: "MAC_ADDRESS",
            value: mac
        },
        assetStatus: INACTIVE
    }
    setAssetLabelInactiveAslDeviceDetails(dispatcher, request)
}

export function deleteAslDeviceConfigDetails(dispatcher, mac, divertCode) {
    const request = {
        assetLabel: {
            type: "MAC_ADDRESS",
            value: mac
        }
    }
    deleteAslAssetConfigDetails(dispatcher, request, divertCode)
}

export function updateAslConfigDetails(dispatcher, divertConfig, mac) {
    const request = {
        assetLabel: {
            type: "MAC_ADDRESS",
            value: mac
        }
    }
    updateAslAssetConfigDetails(dispatcher, request, divertConfig)
}

export function setAslDeviceDetails(dispatcher, stateValues) {
    const request = convertTableJsonToAsset(stateValues, ASL_ASSET_TYPE, ACTIVE);
    addAslDeviceDetails(dispatcher, request)
}

export function updateAslDeviceDetails(dispatcher, stateValues) {
    const request = convertTableJsonToAsset(stateValues, ASL_ASSET_TYPE, ACTIVE);
    updateAslAsset(dispatcher, request)
}

export const updateAslDivertConfig = (result, divertConfig) => {
    const temp = [divertConfig]
    if (checkNullAndUndefinedAttribute(result.assetDetails.assetAttributes.divertConfig)) {
        for (const object of JSON.parse(result.assetDetails.assetAttributes.divertConfig)) {
            if (object.divertCode !== divertConfig.divertCode) {
                temp.push(object)
            }
        }
    }
    result.assetDetails.assetAttributes.divertConfig = JSON.stringify(temp)
    return result;
}

export const deleteAslDivertConfig = (result, divertCode) => {
    const temp = []
    if (divertCode !== ALL_CONFIG) {
        if (checkNullAndUndefinedAttribute(result.assetDetails.assetAttributes.divertConfig)) {
            for (const key of JSON.parse(result.assetDetails.assetAttributes.divertConfig)) {
                if (key.divertCode !== divertCode)
                    temp.push(key)
            }
        }
    }
    result.assetDetails.assetAttributes.divertConfig = JSON.stringify(temp)
    return result;
}

const extractAslDeviceList = (result) => {
    const model = {
        aslDeviceInformation: {},
        macAddressArray: []
    }
    if ("data" in result && "assetDetailsList" in result.data) {
        result.data.assetDetailsList.forEach((aslDeviceDetail) => {
            if (aslDeviceDetail.assetStatus === ACTIVE) {
                model.macAddressArray.push(aslDeviceDetail.assetAttributes.mac)
                const divertConfigModel = {
                    divertConfig: []
                }
                if ("divertConfig" in aslDeviceDetail.assetAttributes) {
                    const divertConfigValueJson = JSON.parse(aslDeviceDetail.assetAttributes.divertConfig);
                    divertConfigValueJson.forEach((divertConfigValue) => {
                        const tempObj = {
                            divertCode: divertConfigValue.divertCode,
                            clusters: divertConfigValue.clusters
                        }
                        divertConfigModel.divertConfig.push(tempObj)
                    })
                }
                const id = JSON.parse(aslDeviceDetail.assetAttributes.deviceConfig).id;
                model.aslDeviceInformation[aslDeviceDetail.assetAttributes.mac] = {
                    name: aslDeviceDetail.assetAttributes.name,
                    mac: aslDeviceDetail.assetAttributes.mac,
                    ip: aslDeviceDetail.assetAttributes.ip,
                    id: id,
                    port: aslDeviceDetail.assetAttributes.port,
                    assetStatus: LOADING_STRING,
                    deviceType: aslDeviceDetail.assetAttributes.deviceType,
                    assetType: aslDeviceDetail.assetType,
                    divertConfig: divertConfigModel.divertConfig // null and undefined check
                    && Object.keys(divertConfigModel.divertConfig).length === 0
                    && Object.getPrototypeOf(divertConfigModel.divertConfig) === Object.prototype ? {} : divertConfigModel.divertConfig
                }
            }
        });
    }
    return model;
}

async function getAslDeviceStatusDetails(dispatcher, model) {
    const request = {
        nodeId: getNodeId(),
        macAddressList: model.macAddressArray
    }
    const startTime = Date.now();
    const args = getAPIGatewayPostRequest(request, ENDPOINT_GET_ASL_STATUS);
    getAPIGatewayDataFromParent(args).then(response => {
        if (response.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "getAslDeviceStatusDetails", true);
            mergeStatusToModel(response, model)
            dispatcher({type: "RECEIVE_DATA", data: model});
        } else {
            logOperationalMetric(startTime, metricProcessName, "getAslDeviceStatusDetails", false);
            request.macAddressList.forEach((macAddress) => {
                model.aslDeviceInformation[macAddress].assetStatus = LOADING_FAILED
            })
            dispatcher({type: "RECEIVE_DATA", data: model});
        }
    })
}

async function getAslDeviceDetails(dispatcher, request) {
    const startTime = Date.now();
    getAssets(request.nodeId, request.assetType).then(result => {
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "getAslDeviceDetails", true);
            const aslDeviceList = extractAslDeviceList(result);
            getAslDeviceStatusDetails(dispatcher, aslDeviceList)
            dispatcher({type: "RECEIVE_DATA", data: aslDeviceList});
        } else {
            logOperationalMetric(startTime, metricProcessName, "getAslDeviceDetails", false);
            dispatcher({type: "RECEIVE_DATA", data: []});
        }
    });
}

async function setAssetLabelInactiveAslDeviceDetails(dispatcher, request) {
    const startTime = Date.now();
    setAssetStatus(request.assetLabel, request.assetStatus).then(result => {
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "deleteAslDeviceDetails", true);
        } else {
            logOperationalMetric(startTime, metricProcessName, "deleteAslDeviceDetails", false);
            dispatcher({type: "RECEIVE_DATA", data: []});
        }
    });
}

async function updateAslAssetConfigDetails(dispatcher, request, divertConfig) {
    // Get existing configuration
    const getResult =  await getAssetByAssetLabel(request.assetLabel);

    // Merge current configuration into existing configuration and update
    const updateStartTime = Date.now();
    const updatedAsset = updateAslDivertConfig(getResult.data.asset, divertConfig)
    const updateResult = await updateAsset(updatedAsset);
    const isUpdateSuccess = updateResult.status === 200;
    if (!isUpdateSuccess) {
        alert(ALERT_UPDATE_ASSET_MESSAGE);
    }
    fetchAslDeviceDetails(dispatcher);

    // Log operation
    logOperationalMetric(updateStartTime, metricProcessName, "updateAslDeviceConfigDetails", isUpdateSuccess);
}

async function deleteAslAssetConfigDetails(dispatcher, request, divertCode) {
    // Get existing configuration
    const getResult = await getAssetByAssetLabel(request.assetLabel);

    // Merge current configuration into existing configuration and update
    const updateStartTime = Date.now();
    const updatedAsset = deleteAslDivertConfig(getResult.data.asset, divertCode);
    const updateResult = await updateAsset(updatedAsset);
    const isUpdateSuccess = updateResult.status === 200;
    if (!isUpdateSuccess) {
        alert(ALERT_UPDATE_ASSET_MESSAGE);
    }
    fetchAslDeviceDetails(dispatcher);

    // Log operation
    logOperationalMetric(updateStartTime, metricProcessName, "deleteAslDeviceConfigDetails", isUpdateSuccess);
}

async function addAslDeviceDetails(dispatcher, request) {
    const startTime = Date.now();
    addAsset(request).then(async result => {
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "addAslDeviceDetails", true);
        } else {
            logOperationalMetric(startTime, metricProcessName, "addAslDeviceDetails", false);
            // 500 response status can be for any reason. One of those is : asset already exists so trying to update it.
            // UpdateAsset only works on ACTIVE devices so first setting status as ACTIVE.
            const responseSetAssetStatus = await setAssetStatus(request.assetDetails.assetLabel, ACTIVE);
            if (responseSetAssetStatus.status !== 200) {
                alert(ALERT_ASSET_STATUS_MESSAGE);
            } else if (responseSetAssetStatus.status === 200) {
                const responseUpdateAsset = await updateAsset(request);
                if (responseUpdateAsset.status !== 200) {
                    alert(ALERT_UPDATE_ASSET_MESSAGE);
                }
            }
        }
        fetchAslDeviceDetails(dispatcher)
    });
}


async function updateAslAsset(dispatcher, request) {
    // Set asset to active first
    const setAssetStatusResponse = await setAssetStatus(request.assetDetails.assetLabel, ACTIVE);
    if (setAssetStatusResponse.status !== 200) {
        alert(ALERT_ASSET_STATUS_MESSAGE);
        fetchAslDeviceDetails(dispatcher)
        return;
    }

    // Update asset details
    const startTime = Date.now();
    const updateAssetResponse = await updateAsset(request);
    const isSuccess = updateAssetResponse.status === 200;
    logOperationalMetric(startTime, metricProcessName, "updateAslDeviceDetails", isSuccess);
    fetchAslDeviceDetails(dispatcher);
}

function mergeStatusToModel(response, model) {
    if ("data" in response && "aslStatusList" in response.data) {
        response.data.aslStatusList.forEach((singleAslDeviceStatusDetail) => {
            model.aslDeviceInformation[singleAslDeviceStatusDetail.mac].assetStatus = singleAslDeviceStatusDetail.status
        })
    }
}



// WEBPACK FOOTER //
// ./src/components/devicemanagement/asldevice/network/AslDeviceOverviewNetworkAPI.js